import { fetcher } from 'utils/axios';
import type { CustomView, FilterGroup } from 'types/userConfig/userConfig';

/**
 * תצוגות מותאמות ברמת חברה — טבלת CompanyCustomViews בשרת הנוד.
 * מחליף את האחסון הפר-משתמשי ב-ProfileConfig.customViews: התצוגות משותפות לחברה,
 * הנראות פר-משתמש היא רשימה לבנה (visibleUserUdids), ועריכה/מחיקה לבעלים או אדמין.
 */

function extractEnvelopeData<T>(response: any): T {
  if (response && typeof response === 'object' && 'data' in response && response.success !== undefined) {
    return response.data as T;
  }
  return response as T;
}

export function extractCustomViewsError(error: unknown, fallback: string): string {
  const anyErr = error as { message?: string; error?: string } | undefined;
  return anyErr?.message || anyErr?.error || fallback;
}

/** כל תצוגות החברה (כולל כאלה שמוסתרות מהמשתמש הנוכחי) — הסינון לנראות נעשה בקליינט */
export async function fetchCompanyCustomViews(): Promise<CustomView[]> {
  const response = await fetcher('get', ['/api/custom-views', {}], 'servernode');
  const views = extractEnvelopeData<CustomView[]>(response);
  return Array.isArray(views) ? views : [];
}

export async function createCompanyCustomView(params: {
  name: string;
  filters: FilterGroup[];
  filtersLogic?: 'or' | 'and';
}): Promise<CustomView> {
  const response = await fetcher('post', ['/api/custom-views', { data: params }], 'servernode');
  return extractEnvelopeData<CustomView>(response);
}

export async function updateCompanyCustomView(
  viewId: string,
  params: {
    name: string;
    filters: FilterGroup[];
    filtersLogic?: 'or' | 'and';
},
): Promise<CustomView> {
  const response = await fetcher('put', [`/api/custom-views/${encodeURIComponent(viewId)}`, { data: params }], 'servernode');
  return extractEnvelopeData<CustomView>(response);
}

export async function deleteCompanyCustomView(viewId: string): Promise<void> {
  await fetcher('delete', [`/api/custom-views/${encodeURIComponent(viewId)}`, {}], 'servernode');
}

/** שיתוף/הסתרה פר-משתמש (רשימה לבנה) — פעולת אדמין במסך ניהול התצוגות */
export async function updateCompanyCustomViewVisibility(
  viewId: string,
  visibleUserUdids: string[],
): Promise<CustomView> {
  const response = await fetcher(
    'put',
    [`/api/custom-views/${encodeURIComponent(viewId)}/visibility`, { data: { visibleUserUdids } }],
    'servernode',
  );
  return extractEnvelopeData<CustomView>(response);
}
